import { Component, ComponentInterface, h, Host } from '@stencil/core';

@Component({
  tag: 'lar-app',
  styleUrl: 'app.scss',
  shadow: false
})
export class LarvaApp implements ComponentInterface {
  render() {
    return (
      <Host class={{ 'lar-app': true }} />
    );
  }
}
